import React, { Component } from 'react';

// import Custom Componenets
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import API_URL, { Post, Delete, Get, JENIS_DESA, ID_DESA, } from '../../../function/Koneksi';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import axios from 'axios';
import Datetime from 'react-datetime';

import L from 'leaflet';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import ReactSelect from 'react-select';

let DefaultIcon = L.icon({
	iconSize: [25, 41],
	iconAnchor: [10, 41],
	iconUrl: icon,
	shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

const currentDate = new Date()
Date.prototype.addDays = function (days) {
	var date = new Date(this.valueOf());
	date.setDate(date.getDate() + days);
	return date;
}

const frmDex = {
	uuid: '',
	nik: '',
	nama: '',
	niap: '',
	nip: '',
	jenis_kelamin: '',
	tempat_lahir: '',
	tanggal_lahir: null,
	agama: '',
	pangkat_golongan: '',
	jabatan: '',
	pendidikan_terakhir: '',
	nomor_pengangkatan: '',
	tanggal_pengangkatan: new Date(),
	nomor_pemberhentian: '',
	tanggal_pemberhentian: new Date(),
	keterangan: '',
}

const dateFormat = require('dateformat');

class MenuA4 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			listPerangkat: [],
			tmplistPerangkat: {},
			detailPerangkat: null,
			status: {
				form: false,
				btnForm: false,
				btnAksi: false
			},
			loading: false,
			loadingPreview: false,
			imagePreview: null,
			detailPreview: false,
			detailData: null,
			awal: '',
			sebelum: '',
			hal: [],
			setelah: '',
			akhir: '',
			dt: frmDex,
			judul: 'Tambah Aparat Pemerintah ' + JENIS_DESA,
			textCari: '',
			alert: null,
			show: false,
			basicTitle: '',
			basicType: 'default',
			pesanAlert: '',
			editMode: false
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	// =================================================

	pagination = data => {
		// const data = this.state.pagination;
		//console.log(data);
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
			let start = 1;
			let end = 5;
			let n = 0;
			let p = 0;
			if (data.current_page <= 3) {
				start = 1;
				end = 5;
				if (data.last_page > data.current_page) {
					n = data.current_page + 1;
				}
			} else {
				p = data.current_page - 1;
				n = data.current_page + 1;
				start = data.current_page - 2;
				end = data.current_page + 2;
			}
			if (end >= data.last_page - 2) {
				p = data.current_page - 1;
				if (start >= 5) {
					start = data.last_page - 4;
				}
				end = data.last_page;
			}

			for (let i = start; i <= end; i++) {
				let warna = "primary-custom";
				if (i === data.current_page) {
					warna = "danger";
				}
				hal.push(
					<a
						onClick={() => this.fetch({ page: i })}
						className={
							"btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
						}
					>
						{i}
					</a>
				);
			}
			if (p > 0) {
				sebelum = (
					<a
						onClick={() => this.fetch({ page: p })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{"<"}
					</a>
				);
			}
			if (n > 0) {
				setelah = (
					<a
						onClick={() => this.fetch({ page: n })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{">"}
					</a>
				);
			}
			awal = (
				<a
					onClick={() => this.fetch({ page: 1 })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{"<<"}
				</a>
			);
			akhir = (
				<a
					onClick={() => this.fetch({ page: data.last_page })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{">>"}
				</a>
			);
		}
		this.setState({ awal, sebelum, hal, setelah, akhir });
	};

	fetch = (params = {}) => {
		this.setState({ loading: true })
		let link = "";
		if (params.page) {
			switch (params.page) {
				case ">>":
					link =
						"?page=" +
						Math.ceil(
							this.state.pagination.total / this.state.pagination.per_page
						);
					break;
				case ">":
					link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
					break;
				case "<":
					link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
					break;
				case "<<":
					link = "?page=1";
					break;
				default:
					link = "?page=" + params.page;
					break;
			}
		}

		// if (this.state.textCari === '') {
		// 	Get("aparat-desa" + link, null, dtkat => {
		// 		// console.log(dtkat);

		// 		if (dtkat.results) {
		// 			this.setState({
		// 				data: dtkat.results.data,
		// 				pagination: dtkat.results,
		// 				loading: false
		// 			})
		// 			this.pagination(dtkat.results);
		// 		}

		// 	});
		// } else { // Jika pencarian
		Post("aparat-desa" + link, null, {
			q: this.state.textCari
		}, dtkat => {
			if (dtkat.data.results) {
				console.log('masuk');
				this.setState({
					data: dtkat.data.results.data,
					pagination: dtkat.data.results,
					loading: false
				})
				this.pagination(dtkat.data.results);
			}

		});
		// }

	};

	// ================== simpan data ==================
	simpan = ((e) => {
		e.preventDefault();

		if (this.state.detailPerangkat) {
			this.setState({ loadingPreview: true })

			let bodyData = this.state.dt
			bodyData = {
				...bodyData,
				keterangan: document.getElementById("keterangan").value,
				tanggal_pengangkatan: dateFormat(bodyData.tanggal_pengangkatan, "yyyy-mm-dd"),
				tanggal_pemberhentian: dateFormat(bodyData.tanggal_pemberhentian, "yyyy-mm-dd"),
			}

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyData.uuid === "") {
				psn = "tambah";
				resstat = 201;
				bodyData.uuid = null;
			} else {
				psn = "ubah";
				resstat = 200;
				metode = "update";
			}

			console.log(bodyData);

			Post('aparat-desa/' + metode, bodyData.uuid, bodyData, res => {
				// console.log(res);
				if (res.status === resstat) {
					this.setState({
						loadingPreview: false,
						show: true,
						basicType: "success",
						basicTitle: "Data Aparat Pemerintah " + JENIS_DESA,
						pesanAlert: "Berhasil " + psn + " Data"
					});

					document.getElementById('form-data').reset()
					this.fetch();
					this.setState({
						dt: frmDex,
						status: {
							...this.state.status,
							form: false
						}
					})
				} else {
					this.setState({
						loadingPreview: false,
						show: true,
						basicType: "danger",
						basicTitle: "Data Aparat Pemerintah " + JENIS_DESA,
						pesanAlert: "Gagal " + psn + " Data"
					});
				}
			})

		} else {
			this.setState({
				show: true,
				basicType: "warning",
				basicTitle: "Data Aparat Pemerintah " + JENIS_DESA,
				pesanAlert: "Pilih Aparat Pemerintah " + JENIS_DESA
			});
		}

	});
	// ========================================================================

	bukaForm = () => {
		this.setState({
			status: {
				...this.state.status,
				form: true,
			},
		})
		this.forceUpdate();
	};

	tutupForm = () => {
		this.setState({
			formDisposisi: false,
			status: {
				...this.state.status,
				form: false,
			},
		})

		this.forceUpdate();
	};

	ubahData = data => {
		this.setState({
			judul: "Ubah Data Aparat Pemerintah " + JENIS_DESA,
			editMode: true
		})

		if (data) {
			this.setState({
				// tmpImages: [],
				dt: {
					...this.state.dt,
					uuid: data.uuid,
					nik: data.nik,
					nama: data.nama,
					nip: data.nip,
					jenis_kelamin: data.jenis_kelamin,
					tempat_lahir: data.tempat_lahir,
					tanggal_lahir: new Date(data.tanggal_lahir),
					agama: data.agama,
					pendidikan_terakhir: data.pendidikan_terakhir,
					jabatan: data.jabatan,

					niap: data.niap,
					pangkat_golongan: data.pangkat_golongan,
					nomor_pengangkatan: data.nomor_pengangkatan,
					// tanggal_pengangkatan: dateFormat(data.tanggal_pengangkatan, "yyyy-mm-dd"),
					tanggal_pengangkatan: data.tanggal_pengangkatan ? new Date(data.tanggal_pengangkatan) : null,
					nomor_pemberhentian: data.nomor_pemberhentian,
					// tanggal_pemberhentian: dateFormat(data.tanggal_pemberhentian, "yyyy-mm-dd"),
					tanggal_pemberhentian: data.tanggal_pemberhentian ? new Date(data.tanggal_pemberhentian) : null,
					keterangan: data.keterangan,
				},
				detailPerangkat: {
					value: data.nik,
					label: `${data.nik} | ${data.nama}`,
				},
				status: {
					...this.state.status,
					form: true
				}
			})
		}
	}

	cariData = (e) => {
		if (e.key === 'Enter') {
			let txt = e.target.value
			this.setState({
				textCari: txt.trim(),
				loading: true
			});
			setTimeout(
				function () {
					this.fetch();
				}.bind(this),
				500
			);
		}
	};

	downloadSurat = () => {
		let token = sessionStorage.getItem("access_token")
			? sessionStorage.getItem("access_token")
			: "public";

		fetch(API_URL + 'aparat-desa/cetak', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/pdf',
				'Authorization': 'Bearer ' + token,
			},
		})
		// .then((response) => response.blob())
		.then((response) => {
			if (response.status == 200) {
				return response.blob()
			}
			this.setState({
				loading: false,
				show: true,
				basicType: 'danger',
				basicTitle: 'Data Aparat ' + JENIS_DESA,
				pesanAlert: 'Gagal cetak surat'
			});
			throw new Error('Something went wrong');
		})
		.then((blob) => {
			// Create blob link to download
			const url = window.URL.createObjectURL(
				new Blob([blob]),
			);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute(
				'download',
				`Aparat Pemerintahan ${JENIS_DESA}.pdf`,
			);

			// Append to html link element page
			document.body.appendChild(link);

			// Start download
			link.click();

			// Clean up and remove the link
			link.parentNode.removeChild(link);
			this.setState({
				loading: false,
			})
		})
		.catch((e) => {
			// console.log(e);
		})
		;
	}

	componentDidMount() {
		this.fetch()
		Get("perangkat/list", null, dtkat => {
			console.log(dtkat);
			if (dtkat.results) {
				// this.setState({ listPerangkat: dtkat.results })
				let frm = [];
				let tmplistPerangkat = {}
				dtkat.results.forEach(dt => {
					if (dt.data_penduduk) {
						frm.push({ value: dt.nik, label: `${dt.nik} | ${dt.data_penduduk.nama}` });
						tmplistPerangkat = {
							...tmplistPerangkat,
							[dt.nik]: dt
						}
					}
				});
				this.setState({ listPerangkat: frm, tmplistPerangkat });
			}
		});
	}

	render() {
		var data = this.state.data;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) => {
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index + 1);
					let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
					return serial_num;
				}
			},
			{
				dataField: 'nama',
				text: 'NAMA',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			// {
			// 	dataField: 'niap',
			// 	text: 'NIAP',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'nip',
			// 	text: 'NIP',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'jabatan',
				text: 'JABATAN',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'nomor_tanggal_pengangkatan',
				text: 'NOMOR DAN TANGGAL KEPUTUSAN PENGANGKATAN',
				headerAlign: 'center',
				align: 'center',
				sort: false,
				formatter: (cell, row) => {
					if (row) {
						return `${row.nomor_pengangkatan} / ${row.tanggal_pengangkatan}`
					}
					return '';
				}
			},
			{
				dataField: 'nomor_tanggal_pemberhentian',
				text: 'NOMOR DAN TANGGAL KEPUTUSAN PEMBERHENTIAN',
				headerAlign: 'center',
				align: 'center',
				sort: false,
				formatter: (cell, row) => {
					if (row) {
						return `${row.nomor_pemberhentian} / ${row.tanggal_pemberhentian}`
					}
					return '';
				}
			},
			// {
			// 	dataField: 'keterangan',
			// 	text: 'KET.',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'aksi',
				text: 'Aksi',
				headerAlign: 'center',
				align: 'center',
				formatter: function (cell, row) {
					return (
						<div style={{ minWidth: "61px" }}>
							<Button
								size="xs"
								color="success"
								className="btn-icon mr-2"
								onClick={() => this.ubahData(row)}
							// disabled={btnAksi}
							>
								<i className="fa fa-pencil"></i>
							</Button>{" "}
							<Button
								size="xs"
								color="info"
								className="btn-icon mr-2"
								onClick={() => {
									this.setState({
										detailPreview: true,
										detailData: row
									})
								}}
							>
								<i className="fa fa-eye"></i>
							</Button>{" "}
							<Button
								size="xs"
								color="danger"
								className="btn-icon"
								onClick={() => {
									this.setState({
										alert: (
											<SweetAlert
												showCancel
												confirmBtnText="Hapus"
												confirmBtnBsStyle="danger"
												cancelBtnBsStyle="success"
												type="danger"
												title="Yakin ingin hapus data ?"
												onCancel={this.hideAlert}
												onConfirm={() => {
													Delete('aparat-desa/delete', row.uuid, (res) => {
														if (res === 200) {
															this.setState({
																show: true,
																basicType: 'success',
																basicTitle: 'Data Aparat Pemerintah ' + JENIS_DESA,
																pesanAlert: 'Berhasil hapus data'
															});
															this.fetch()
														} else {
															this.setState({
																show: true,
																basicType: 'danger',
																basicTitle: 'Data Aparat Pemerintah ' + JENIS_DESA,
																pesanAlert: 'Gagal hapus data'
															});
														}
														this.setState({ alert: null })
													})
												}}
											>
												Proses ini tidak dapat dibatalkan!
											</SweetAlert>
										)
									});
								}}
								disabled={this.state.status.btnAksi}
							>
								<i className="fa fa-trash"></i>
							</Button>
						</div>
					)
				}.bind(this)
			}
		]

		return (
			<div>
				{/* <Breadcrumb title="Data Aparat Pemerintah Desa" parent="Admin" /> */}
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				<SweetAlert
					show={this.state.loadingPreview}
					showCancel={false}
					showConfirm={false}
				>
					<div align="center">
						{/* <h5 className="modal-title mb-3" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5> */}
						<img
							alt="loading"
							src={require("../../../assets/images/tes-loading.gif")}
							style={{
								borderRadius: "10px",
								width: '150px'
							}}
						/>
					</div>
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-header">
									<div className="row">
										<div className="col-sm-6 text-left">
											<Button
												size="sm"
												color="default"
												style={{ backgroundColor: '#FFC312' }}
												onClick={this.props.history.goBack}
											>
												<i className="fa fa-arrow-left"></i> Kembali
											</Button>
										</div>
										<div className="col-sm-6 text-right">
											<Button
												size="sm"
												color="info"
												className="btn-icon mr-2"
												onClick={() => {
													this.setState({ loading: true })
													this.downloadSurat()
												}}
											>
												Cetak
											</Button>{" "}
											<Button
												size="sm"
												color="success"
												className="btn-square"
												onClick={() => {
													this.setState({
														judul: 'Tambah Aparat ' + JENIS_DESA,
														dt: frmDex,
														tmpImages: ['kosong'],
														editMode: false,
														detailPerangkat: null,
														currentLocation: this.state.curStaticLocation
													});
													// document.getElementById('form-data').reset()
													this.bukaForm();
												}}
											>
												Tambah Data
											</Button>
										</div>
									</div>
								</div>

								<div className="card-body datatable-react custom-font-sm">
									{/* <div className="row">
										<div className="col-md-12"> */}
									{this.state.loading ? (
										<div className="row">
											<div className="col-sm-12" align="center">
												<img
													alt="loading"
													src={require("../../../assets/images/tes-loading.gif")}
													style={{
														borderRadius: "10px",
														width: '100px'
													}} />
											</div>
										</div>
									) : (
										<div className='row'>
											<div className="col-md-5 text-right">
												<input
													type="text"
													className="form-control"
													style={{ marginBottom: '15px' }}
													id="cariTable"
													placeholder={"Cari berdasarkan nama, niap, atau nip"}
													defaultValue={this.state.textCari}
													onChange={(e) => {
														this.setState({ textCari: e.target.value })
													}}
													onKeyPress={this.cariData}
												/>
												<div className="clearBtnSearch" style={{ display: this.state.textCari !== '' ? 'inline' : '' }}>
													<span className='fa fa-close' style={{ fontSize: '1.3em', cursor: 'pointer' }} onClick={() => {
														this.setState({
															textCari: '',
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
														document.getElementById('cariTable').value = ''
													}} ></span>
												</div>
											</div>
											<div className="col-md-7" style={{ marginBottom: '15px' }}>
												<Button
													size="sm"
													color="info"
													className="btn-square"
													onClick={() => {
														this.setState({
															textCari: document.getElementById("cariTable").value,
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
													}}
												>
													<i className="fa fa-search"></i>
												</Button>
											</div>
											{data.length > 0 ? (
												<>
													<div className="col-md-12">
														<BootstrapTable
															keyField="id"
															data={data}
															columns={columns}
														/>
														<div className="pull-right text-white">
															{this.state.awal}
															{this.state.sebelum}
															{this.state.hal.map(dt => {
																return dt;
															})}
															{this.state.setelah}
															{this.state.akhir}
														</div>
													</div>
												</>
											) : (
												<div className="col-md-12">
													<h6 className="text-center mb-2 mt-2">Data tidak ditemukan</h6>
												</div>
											)}
										</div>
									)}
									{/* </div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				<Modal
					open={this.state.detailPreview ? true : false}
					onClose={() => {
						this.setState({ detailPreview: false })
					}}
					closeOnEsc={true}
					closeOnOverlayClick={true}
					styles={{ modal: { width: '50%', maxWidth: 'unset' } }}
				>
					<div className="modal-header">
						<h5 className="modal-title" style={{ fontWeight: 'bold' }}>Detail Data Aparat {JENIS_DESA}</h5>
					</div>
					<div className="modal-body">
						<div className="row">
							<div className="col-md-12">
								{this.state.detailData ? (
									<>
										<div className="table-responsive">
											<table className='detail-dokumen-administrasi'>
												<tbody>
													<tr>
														<th width="280">Nama</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.nama}</span></td>
													</tr>
													<tr>
														<th width="280">NIK</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.nik}</span></td>
													</tr>
													<tr>
														<th width="280">NIAP</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.niap}</span></td>
													</tr>
													<tr>
														<th width="280">NIP</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.nip}</span></td>
													</tr>
													<tr>
														<th width="280">Jenis Kelamin</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.jenis_kelamin}</span></td>
													</tr>
													<tr>
														<th width="280">Tempat / Tanggal Lahir</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.tempat_lahir + ", " + this.state.detailData.tanggal_lahir}</span></td>
													</tr>
													<tr>
														<th width="280">Agama</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.agama}</span></td>
													</tr>
													<tr>
														<th width="280">Pangkat Golongan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.pangkat_golongan}</span></td>
													</tr>
													<tr>
														<th width="280">Jabatan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.jabatan}</span></td>
													</tr>
													<tr>
														<th width="280">Pendidikan Terakhir</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.pendidikan_terakhir}</span></td>
													</tr>
													<tr>
														<th width="280">Nomor dan Tanggal Keputusan Pengangkatan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.nomor_pengangkatan + ' / ' + this.state.detailData.tanggal_pengangkatan}</span></td>
													</tr>
													<tr>
														<th width="280">Nomor dan Tanggal Keputusan Pemberhentian</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.nomor_pemberhentian + ' / ' + this.state.detailData.tanggal_pemberhentian}</span></td>
													</tr>
													<tr>
														<th width="280">Keterangan Tambahan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.keterangan}</span></td>
													</tr>
												</tbody>
											</table>
										</div>
									</>
								) : ''}
							</div>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.status.form}
					onClose={this.tutupForm}
					closeOnEsc={false}
					closeOnOverlayClick={false}
					styles={{ modal: { width: '60%', maxWidth: "unset" } }}
				>
					<Form id="form-data" className="theme-form" onSubmit={(e) => { this.simpan(e) }}>
						<input className="form-control" id="uuid" type="hidden" defaultValue={this.state.dt.uuid} value={this.state.dt.uuid} />
						<div className="modal-header">
							<h5 className="modal-title" style={{ fontWeight: 'bold' }}>{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							{/* <input
								className="form-control"
								id="uuid"
								type="hidden"
								placeholder="UUID"
								defaultValue={this.state.dt.uuid}
								value={this.state.dt.uuid}
							/> */}

							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Aparat Pemerintah {JENIS_DESA}</Label>
									<ReactSelect
										inputId="detail_perangkat"
										classNamePrefix="select"
										isClearable
										onChange={e => {
											this.setState({ detailPerangkat: e })
											if (e) {
												const perangkatSelected = this.state.tmplistPerangkat[e.value]

												this.setState({
													dt: {
														...this.state.dt,
														nik: perangkatSelected.nik,
														nama: perangkatSelected.data_penduduk.nama,
														nip: perangkatSelected.nip !== '' ? perangkatSelected.nip : '-',
														jenis_kelamin: perangkatSelected.data_penduduk.jk,
														tempat_lahir: perangkatSelected.data_penduduk.tempat_lahir,
														tanggal_lahir: perangkatSelected.data_penduduk.tanggal_lahir,
														jabatan: perangkatSelected.data_jabatan.nama,
														agama: perangkatSelected.data_penduduk.data_agama.nama,
														pendidikan_terakhir: perangkatSelected.data_penduduk.data_pendidikan_terakhir.nama,
													}
												})
											}
										}}
										defaultValue={this.state.detailPerangkat}
										value={this.state.detailPerangkat}
										options={this.state.listPerangkat}
										placeholder={"Pilih Aparat Pemerintah " + JENIS_DESA}
									/>
								</Col>
							</div>

							<div style={{ display: this.state.detailPerangkat ? 'block' : 'none' }}>
								<div className="form-row">
									<Col sm="12 mb-2">
										<Label htmlFor="validationCustom05">Nama</Label>
										<input
											className="form-control placeholder-sm"
											id="nama"
											type="text"
											value={this.state.dt.nama}
											readOnly
											disabled
											style={{ backgroundColor: "#c9d1d8" }}
											placeholder="Masukkan nama"
											onChange={(e) => {
												this.setState({
													dt: {
														...this.state.dt,
														nama: e.target.value
													}
												})
											}}
											required
										/>
									</Col>
									<Col sm="12 mb-2">
										<Label htmlFor="validationCustom05">NIP</Label>
										<input
											className="form-control placeholder-sm"
											id="nip"
											type="text"
											value={this.state.dt.nip}
											readOnly
											disabled
											style={{ backgroundColor: "#c9d1d8" }}
											placeholder="Masukkan nip"
											onChange={(e) => {
												this.setState({
													dt: {
														...this.state.dt,
														nip: e.target.value
													}
												})
											}}
											required
										/>
									</Col>
									<Col sm="12 mb-2">
										<Label htmlFor="validationCustom05">Jenis Kelamin</Label>
										<input
											className="form-control placeholder-sm"
											id="jenis_kelamin"
											type="text"
											value={this.state.dt.jenis_kelamin}
											readOnly
											disabled
											style={{ backgroundColor: "#c9d1d8" }}
											placeholder="Masukkan nama"
											onChange={(e) => {
												this.setState({
													dt: {
														...this.state.dt,
														jenis_kelamin: e.target.value
													}
												})
											}}
											required
										/>
									</Col>
									<Col sm="12 mb-2">
										<Label htmlFor="validationCustom05">Tempat Lahir</Label>
										<input
											className="form-control placeholder-sm"
											id="tempat_lahir"
											type="text"
											value={this.state.dt.tempat_lahir}
											readOnly
											disabled
											style={{ backgroundColor: "#c9d1d8" }}
											placeholder="Masukkan tempat_lahir"
											onChange={(e) => {
												this.setState({
													dt: {
														...this.state.dt,
														tempat_lahir: e.target.value
													}
												})
											}}
											required
										/>
									</Col>
									<Col sm="12 mb-2">
										<Label htmlFor="validationCustom05">Agama</Label>
										<input
											className="form-control placeholder-sm"
											id="agama"
											type="text"
											value={this.state.dt.agama}
											readOnly
											disabled
											style={{ backgroundColor: "#c9d1d8" }}
											placeholder="Masukkan agama"
											onChange={(e) => {
												this.setState({
													dt: {
														...this.state.dt,
														agama: e.target.value
													}
												})
											}}
											required
										/>
									</Col>
									<Col sm="12 mb-2">
										<Label htmlFor="validationCustom05">Pendidikan Terakhir</Label>
										<input
											className="form-control placeholder-sm"
											id="pendidikan_terakhir"
											type="text"
											value={this.state.dt.pendidikan_terakhir}
											readOnly
											disabled
											style={{ backgroundColor: "#c9d1d8" }}
											placeholder="Masukkan pendidikan_terakhir"
											onChange={(e) => {
												this.setState({
													dt: {
														...this.state.dt,
														pendidikan_terakhir: e.target.value
													}
												})
											}}
											required
										/>
									</Col>
									<Col sm="12 mb-2">
										<Label htmlFor="validationCustom05">Jabatan</Label>
										<input
											className="form-control placeholder-sm"
											id="jabatan"
											type="text"
											value={this.state.dt.jabatan}
											readOnly
											disabled
											style={{ backgroundColor: "#c9d1d8" }}
											placeholder="Masukkan jabatan"
											onChange={(e) => {
												this.setState({
													dt: {
														...this.state.dt,
														jabatan: e.target.value
													}
												})
											}}
											required
										/>
									</Col>
									<Col sm="12 mb-2">
										<Label htmlFor="validationCustom05">Jabatan</Label>
										<input
											className="form-control placeholder-sm"
											id="jabatan"
											type="text"
											value={this.state.dt.jabatan}
											readOnly
											disabled
											style={{ backgroundColor: "#c9d1d8" }}
											placeholder="Masukkan jabatan"
											onChange={(e) => {
												this.setState({
													dt: {
														...this.state.dt,
														jabatan: e.target.value
													}
												})
											}}
											required
										/>
									</Col>
								</div>
							</div>

							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">NIAP</Label>
									<input
										className="form-control placeholder-sm"
										id="niap"
										type="text"
										placeholder={`Nomor Induk Aparat Pemerintah ${JENIS_DESA} bagi yang bukan PNS`}
										defaultValue={this.state.dt.niap}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													niap: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Pangkat Golongan</Label>
									<input
										className="form-control"
										id="pangkat_golongan"
										type="text"
										placeholder={`Pangkat / Golongan aparat ${JENIS_DESA} bagi PNS.`}
										defaultValue={this.state.dt.pangkat_golongan}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													pangkat_golongan: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							{/* <FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="nik"
								>
									Tentang
								</Label>
								<Col sm="9">
									<textarea className='form-control' name="tentang" id="tentang" cols="30" placeholder='Masukkan judul/penamaan Aparat Pemerintah Desa' defaultValue={this.state.dt.tentang} rows="2" required />
								</Col>
							</FormGroup> */}

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>Nomor dan tanggal keputusan pengangkatan</b>
								</Label>
							</FormGroup>
							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Nomor Keputusan</Label>
									<input
										className="form-control"
										id="nomor_pengangkatan"
										type="text"
										placeholder={`Nomor keputusan pengangkatan Perangkat ${JENIS_DESA} dan anggota BPD.`}
										defaultValue={this.state.dt.nomor_pengangkatan}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													nomor_pengangkatan: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Tanggal pengangkatan</Label>
									<Datetime
										inputProps={{
											"data-testid": "tanggal_pengangkatan",
											required: true
										}}
										inputId="tanggal_pengangkatan"
										name="tanggal_pengangkatan"
										locale="id-ID"
										timeFormat={false}
										dateFormat="DD/MM/yyyy"
										closeOnTab={true}
										closeOnSelect={true}
										initialValue={this.state.dt.tanggal_pengangkatan}
										value={this.state.dt.tanggal_pengangkatan}
										onChange={e => {
											if (typeof e._isValid !== 'undefined') {
												let tgl = e.format('YYYY-MM-DD');
												this.setState({
													dt: {
														...this.state.dt,
														tanggal_pengangkatan: new Date(tgl)
													}
												})
											}
										}}
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>Nomor dan tanggal keputusan pemberhentian</b>
								</Label>
							</FormGroup>
							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Nomor Keputusan</Label>
									<input
										className="form-control"
										id="nomor_pemberhentian"
										type="text"
										// placeholder={`Nomor keputusan pemberhentian.`}
										placeholder={`Nomor keputusan pemberhentian Perangkat ${JENIS_DESA} dan anggota BPD.`}
										defaultValue={this.state.dt.nomor_pemberhentian}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													nomor_pemberhentian: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Tanggal pemberhentian</Label>
									<Datetime
										inputProps={{
											"data-testid": "tanggal_pemberhentian",
											required: true
										}}
										inputId="tanggal_pemberhentian"
										name="tanggal_pemberhentian"
										locale="id-ID"
										timeFormat={false}
										dateFormat="DD/MM/yyyy"
										closeOnTab={true}
										closeOnSelect={true}
										initialValue={this.state.dt.tanggal_pemberhentian}
										value={this.state.dt.tanggal_pemberhentian}
										onChange={e => {
											if (typeof e._isValid !== 'undefined') {
												let tgl = e.format('YYYY-MM-DD');
												this.setState({
													dt: {
														...this.state.dt,
														tanggal_pemberhentian: new Date(tgl)
													}
												})
											}
										}}
									/>
								</Col>
							</div>

							<hr />

							<div className="form-row">
								<Col sm="12">
									<Label htmlFor="validationCustom05">Keterangan tambahan</Label>
									<textarea className='form-control' name="keterangan" id="keterangan" cols="30" placeholder='Diisi dengan catatan-catatan lain yang dianggap perlu.' defaultValue={this.state.dt.keterangan} rows="3" />
								</Col>
							</div>

						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-warning"
								disabled={this.state.status.btnForm}
								onClick={this.tutupForm}
							>
								Tutup
							</button>
							<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm}>
								Simpan
							</button>
						</div>
					</Form>
				</Modal>
			</div>
		);
	}
}

export default MenuA4;
